import { Flex, Td, Text, Tooltip, Tr, useToast } from "@chakra-ui/react";
import { JobCircularScore } from "components";
import { SuccessToastHandler } from "components/helpers/ToastHelpers";
import {
  aiScoresGroup,
  preferenceScoreGroup,
  sectorDict,
  status,
} from "config/Consts";
import parse from "html-react-parser";
import { useGetUserProfileQuery } from "queries";
import { useGetScoresQuery, useUpdateAppliedJobQuery } from "queries/Jobs";
import { Fragment, useCallback, useEffect, useState } from "react";
import RenderColumns from "./RenderColumns";
const columns = [
  "Company",
  "Job Title",
  "Status",
  "Hours per week",
  "Hourly Pay",
];

const toastField: { [key: string]: string } = {
  status: columns[2],
  hoursPerWeek: columns[3],
  hourlyPay: columns[4],
};

let sortedColumn: string;

const selectOptions: any = {
  status: [
    // "Saved - Not applied to",
    // "Applied - Have not heard back",
    // "Applied - Scheduled interview",
    // "Applied - Received offer!",
    // "Applied - Rejected",
    // "Might apply later",
    ...status.slice(2),
  ],
  hoursPerWeek: ["20 hours", "30 hours", "40 hours", "50 hours"],
  hourlyPay: ["$ 9", "$ 15", "$ 18", "$ 20"],
};

const TableRow = ({
  job,
  jobIdx,
  setAppliedJobs,
}: {
  job: any;
  jobIdx: number;
  setAppliedJobs: (arg?: any) => void;
}): JSX.Element => {
  const [isRowOpen, setRowOpen] = useState<boolean>(false);
  const [updateJobPayload, setUpdateJobPaylaod] = useState<any>({
    id: job?._id,
  });
  const [hpw, setHpw] = useState<number>();

  const { data: userData } = useGetUserProfileQuery();
  const { data: scores }: any = useGetScoresQuery();
  const { mutate: updateAppliedJobData } = useUpdateAppliedJobQuery();
  const { data: score }: any = useGetScoresQuery();

  const aiScore = score?.aiScore[sectorDict[job?.job?.sectorId]];

  const [jobObj, setJobObj] = useState({}) as any;
  const toast = useToast();

  const handleUpdateJobPayload = useCallback(
    ({ fieldName, value }: { fieldName: string; value: string }): void => {
      setJobObj((prev: any) => ({ ...prev, [fieldName]: value })); // just for reflect changes on UI
      const payload = { ...jobObj, [fieldName]: value };
      const updatedJob = { ...job, [fieldName]: value };

      payload.jobTitle = payload.title;
      setAppliedJobs((prev: any) => {
        prev[jobIdx] = updatedJob;
        return [...prev];
      });
      delete payload.title;
      updateAppliedJobData(payload, {
        onSuccess: () => {
          SuccessToastHandler({
            toast,
            title: "Success! 🎉",
            description: `${toastField[fieldName]} updated successfully`,
          });
        },
      });
    },
    [jobObj]
  );

  // update jobObj as the received job updated
  useEffect(() => {
    if (job?.job as boolean) {
      setJobObj({
        company: job?.job?.CompanyName,
        title: job?.job?.title,
        status: job?.status,
        hoursPerWeek: job?.hoursPerWeek,
        hourlyPay: job?.hourlyPay,
        id: job?._id,
      });
    }
  }, [job?.job]);

  useEffect(() => {
    setHpw(job?.hoursPerWeek);
  }, [job?.hoursPerWeek]);

  return (
    <Fragment>
      <Tooltip
        label={isRowOpen ? "" : "Click to know more about the job"}
        placement="top"
        hasArrow
        fontSize={{ base: 14, md: 16 }}
        p={{ base: 2, md: 3 }}
      >
        <Tr
          _hover={{ background: "rgba(214, 158, 46, 0.28);" }}
          background={isRowOpen ? "rgba(214, 158, 46, 0.28)" : "initial"}
          className="transition-all "
          sx={{
            "& td": {
              fontSize: 16,
            },
          }}
        >
          {Object.keys(jobObj ?? {}).map((prop, idx) => {
            return prop !== "id" ? (
              <RenderColumns
                idx={idx}
                prop={prop}
                value={jobObj[prop]}
                isOpen={isRowOpen}
                handleOpen={setRowOpen}
                setPayload={handleUpdateJobPayload}
                hpw={hpw}
                setHpw={setHpw}
                key={idx}
                jobObj={jobObj}
                href={idx === 1 ? job?.job?.guid : null}
              />
            ) : null;
          })}
        </Tr>
      </Tooltip>
      {isRowOpen && (
        <Tr background="rgba(214, 158, 46, 0.28);" whiteSpace="pre-wrap">
          <Td colSpan={5}>
            <Flex my={4} gap={8}>
              {aiScoresGroup.includes(userData?.group) && (
                <Flex className="items-center gap-4">
                  <JobCircularScore value={aiScore} color="hjsAiScore" />
                  <Text fontWeight={600} className="font-size-xs">
                    AI Score
                  </Text>
                </Flex>
              )}
              {preferenceScoreGroup.includes(userData?.group) &&
                (job?.job?.score as boolean) && (
                  <Flex className="items-center gap-4 ">
                    <JobCircularScore value={job?.job?.score} />
                    <Text className="font-size-xs" fontWeight={600}>
                      Preference Score
                    </Text>
                  </Flex>
                )}
            </Flex>
            <span className="text-lg  font-medium">Description -</span>
            <br />
            <span className="text-md leading-7">
              {parse(job?.job?.JobBody)}
            </span>{" "}
          </Td>
        </Tr>
      )}
    </Fragment>
  );
};

export default TableRow;
